/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const IndentMoreIcon = /*#__PURE__*/ createSvgIcon(
  'IndentMoreIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M3.75 17a.728.728 0 01-.534-.214.72.72 0 01-.216-.532c0-.21.072-.39.216-.535a.72.72 0 01.534-.219h12.5c.212 0 .39.072.534.214a.72.72 0 01.216.532c0 .21-.072.39-.216.535a.72.72 0 01-.534.219H3.75zm6-3.125a.728.728 0 01-.534-.214.72.72 0 01-.216-.532c0-.21.072-.39.216-.535a.72.72 0 01.534-.219h6.5c.212 0 .39.072.534.214a.72.72 0 01.216.532c0 .21-.072.39-.216.535a.72.72 0 01-.534.219h-6.5zm0-3.125a.728.728 0 01-.534-.214.72.72 0 01-.216-.532c0-.21.072-.39.216-.535a.72.72 0 01.534-.219h6.5c.212 0 .39.071.534.214a.72.72 0 01.216.532c0 .21-.072.39-.216.535a.72.72 0 01-.534.219h-6.5zm0-3.125a.728.728 0 01-.534-.214A.72.72 0 019 6.879c0-.21.072-.39.216-.535a.72.72 0 01.534-.219h6.5c.212 0 .39.071.534.214a.72.72 0 01.216.532c0 .21-.072.39-.216.535a.72.72 0 01-.534.219h-6.5zm-6-3.125a.728.728 0 01-.534-.214A.72.72 0 013 3.754c0-.21.072-.39.216-.535A.72.72 0 013.75 3h12.5c.212 0 .39.071.534.214a.72.72 0 01.216.532c0 .21-.072.39-.216.535a.72.72 0 01-.534.219H3.75zm-.104 7.854c-.111.111-.247.138-.406.08-.16-.058-.24-.168-.24-.33V7.896c0-.162.08-.272.24-.33.16-.058.295-.031.406.08l2.076 2.076a.377.377 0 01.111.278.377.377 0 01-.11.278l-2.077 2.076z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default IndentMoreIcon;
